/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, DateRange, mp, mixpanel */

// provides the base for the mp.marketing.reports classes

// enable exporting modules for highcharts
// https://www.npmjs.com/package/highcharts#load-highcharts-as-a-commonjs-module
delete window.Highcharts;
window.Highcharts = require(`highcharts`);
require(`highcharts/modules/exporting`)(window.Highcharts);
require(`highcharts/modules/offline-exporting`)(window.Highcharts);

const merge = require(`lodash/merge`);

_.namespace(`mp.marketing.trends.widgets`, function(ns) {
  'use strict';

  ns.TrendReport = Backbone.Widget.extend({
    templates: {
      'base': `#trend_report_base`,
    },

    initialize() {
      this.api = this.options.api;
      this.session = this.options.session;
      this.color_scheme = this.options.color_scheme;
      this.asterisk = this.options.asterisk;

      this.render_base_template();

      // Render an empty chart so loading doesn't look weird
      this.highchart = mp.charts.chart(
        // Use of merge has potential security issues, since we are using lodash >= 4.17.5 it is safe
        // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
        merge(
          {
            exporting: {
              enabled: false,
            },
          },
          this.getChartParamOverrides(),
        ),
      );
      this._show_loader();

      this.on(`ready`, this.on_ready);
      this.on(`close`, this.on_close);
    },

    getChartParamOverrides(ignoreXAxis) {
      const ignoreXAxisParam = ignoreXAxis ? ignoreXAxis : false;
      return {
        chart: {
          allowHTML: true,
          events: {
            load: function() { // eslint-disable-line object-shorthand
              // https://api.highcharts.com/class-reference/Highcharts.SVGRenderer#image
              this.renderer
                .image(`/site_media/images/marketing/trends/logo-opaque.svg`, 290, 130, 400, 132) // (x, y, width, height)
                .add();
            },
          },
          width: 940,
          renderTo: this.$(`.highchart`).get(0),
          backgroundColor: `#fff`,
        },
        xAxis: {
          labels: {
            formatter: ignoreXAxisParam ? null : function() { // eslint-disable-line object-shorthand
              return window.Highcharts.dateFormat(`%b. %e '%y`, this.value);
            },
          },
        },
        legend: {
          align: `left`,
          enabled: true,
          width: 900,
          x: 0,
          y: 10,
        },
        exporting: {
          enabled: false,
          allowHTML: true,
          enableImages: true,
        },
      };
    },

    on_ready() {
      this.init_download_button();
      this._run_queries();
      this.session.on(`change`, this._run_queries, this);
    },

    on_close() {
      this.session.off(null, null, this);
    },

    init_download_button() {

      this.downloadButton = document.querySelector(`mp-button.trends-download`);

      if (this.downloadButton) {
        this.downloadButton.addEventListener(`click`, () => {
          const reportName = this.getDownloadName();
          mixpanel.track(`[trends] Downloaded Trends Report`, {'Report name': reportName});
          this.highchart.exportChartLocal({
            filename: `Trends report by Mixpanel - ${reportName}`,
            type: `image/png`,
            scale: 4,
          });
        });
      }
    },

    get_defaults() {
      return {
        date_range: new DateRange(new Date(2013, 1, 5), new Date()),
      };
    },

    get_queries() {
      throw new Error(`UNIMPLEMENTED`); // For subclasses
    },

    getDownloadName() {
      return `Trends report`;
    },

    _run_queries() {
      var queries = this.get_queries(),
        queries_remaining = _.keys(queries).length,
        query_data = {};

      this._show_loader();

      _.each(queries, function(params, query_name) {
        this.api.query(params, _.bind(function(data) {
          if (data.error) {
            this._query_error(params, data.message);
          } else {
            queries_remaining--;
            query_data[query_name] = data.data.values;
            if (queries_remaining <= 0) {
              // all queries received
              this._render_chart(query_data);
            }
          }
        }, this));
      }, this);
    },

    _query_error(params, message) {
      mp.marketing.trends.session.trigger(`query_error`, params, message);
      this._display_note(`error`, _.truncate(message, 64));
    },

    _render_chart(query_data) {
      if (this.downloadButton) {
        this.downloadButton.setAttribute(`disabled`, false);
      }

      this._hide_notes();
      // For ios-frag chart, we need to remove xAxis override param since it is not a line chart but a bar chart
      const ignoreXAxisParam = window.location.hash.indexOf(`ios_frag`) !== -1;
      // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
      const chartParams = merge(this.get_chart_params(query_data), this.getChartParamOverrides(ignoreXAxisParam));
      this.highchart = mp.charts.chart(chartParams);
    },

    // HELPERS
    _top_n_segments(values, n) {
      return _(values).chain()
        .map(function(total, segment) {
          return [segment, total];
        })
        .sortBy(function(pair) { return -pair[1]; })
        .first(n)
        .map(function(pair) { return pair[0]; })
        .value();
    },

    _show_loader() {
      this._display_note(`loading`);
      if (this.downloadButton) {
        this.downloadButton.setAttribute(`disabled`, true);
      }
    },

    _display_note(note_type, message) {
      var note = this.$(`.note.` + note_type).show();
      this.$(`.notes`).show();

      note.siblings().hide();
      note.find(`.msg`).text(message);

      note.css({
        left: 483 - 110,
        top: 200 - 36.5,
      });
    },

    _hide_notes() {
      this.$(`.notes, .notes > *`).hide();
    },
  });
});

}.call(window));